export default "/_next/static/images/c325e817dcc36d8d7441550888454997.jpg";